import { login } from "./login";
import {
  getBiometricCredentials,
  saveBiometricCredentials,
  deleteBiometricCredentials,
  checkBiometricAvailable,
  isBiometricEnabled,
  getLastBiometricUser,
} from "../../../services/biometric/biometricService";
import {
  BIOMETRIC_AVAILABLE,
  BIOMETRIC_NOT_AVAILABLE,
  BIOMETRIC_ENABLED,
  BIOMETRIC_DISABLED,
  BIOMETRIC_LOGIN_SUCCESS,
  BIOMETRIC_LOGIN_ERROR,
} from "../../ActionTypes";

/**
 * Verifica si la biometría está disponible en el dispositivo
 */
export const checkBiometric = () => async (dispatch) => {
  try {
    const { isAvailable, biometryType } = await checkBiometricAvailable();
    
    if (isAvailable) {
      dispatch({
        type: BIOMETRIC_AVAILABLE,
        payload: { isAvailable, biometryType },
      });
    } else {
      dispatch({
        type: BIOMETRIC_NOT_AVAILABLE,
      });
    }
    
    return { isAvailable, biometryType };
  } catch (error) {
    dispatch({
      type: BIOMETRIC_NOT_AVAILABLE,
    });
    return { isAvailable: false, biometryType: 0 };
  }
};

/**
 * Login usando autenticación biométrica
 * Recupera las credenciales guardadas y hace login normal
 */
export const loginWithBiometric =
  (sectorTurno, nexStep, onError) => async (dispatch) => {
    try {
      // Obtener credenciales usando biometría
      const { dni, password } = await getBiometricCredentials(
        "Inicia sesión con tu huella digital"
      );

      // Hacer login normal con las credenciales recuperadas
      login(
        { txtDni: dni, txtPassword: password },
        sectorTurno,
        (token, data) => {
          dispatch({
            type: BIOMETRIC_LOGIN_SUCCESS,
          });
          if (nexStep) {
            nexStep(token, data);
          }
        }
      )(dispatch);
    } catch (error) {
      console.error("Error en login biométrico:", error);
      dispatch({
        type: BIOMETRIC_LOGIN_ERROR,
        payload: {
          detail: "Error al autenticar con biometría",
          origen: "biometric",
        },
      });
      if (onError) {
        onError(error);
      }
    }
  };

/**
 * Habilita la autenticación biométrica guardando las credenciales
 */
export const enableBiometric =
  (dni, password, onSuccess, onError) => async (dispatch) => {
    try {
      await saveBiometricCredentials(dni, password);
      
      dispatch({
        type: BIOMETRIC_ENABLED,
        payload: { dni },
      });
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error al habilitar biometría:", error);
      if (onError) {
        onError(error);
      }
    }
  };

/**
 * Deshabilita la autenticación biométrica eliminando las credenciales
 */
export const disableBiometric = (onSuccess, onError) => async (dispatch) => {
  try {
    await deleteBiometricCredentials();
    
    dispatch({
      type: BIOMETRIC_DISABLED,
    });
    
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error("Error al deshabilitar biometría:", error);
    if (onError) {
      onError(error);
    }
  }
};

/**
 * Verifica si el usuario tiene la biometría habilitada
 */
export const checkBiometricEnabled = () => async (dispatch) => {
  try {
    const enabled = await isBiometricEnabled();
    const lastUser = await getLastBiometricUser();
    
    if (enabled) {
      dispatch({
        type: BIOMETRIC_ENABLED,
        payload: { dni: lastUser },
      });
    }
    
    return { enabled, lastUser };
  } catch (error) {
    console.error("Error checking biometric enabled:", error);
    return { enabled: false, lastUser: null };
  }
};

